import React, { useState, useEffect, useCallback, useContext, createContext } from "react";
import { GoogleMap, InfoWindow, Marker, MarkerClusterer, useJsApiLoader } from "@react-google-maps/api";
import { withLinkParams } from "shared/product-link";

const Map = ({ products, cdnPath, highlighted, highlightItem }) => {

  const [markerArray, setmarkerArray] = useState();

  const markersArray = []

  useEffect(() => {

    products.map((value, idx) => {

        if( Number(value.lat) != 0 && Number(value.lon) != 0 ) {
          markersArray.push({
             id: value.id,
             name: value.name,
             supplier: value.supplier.name,
             price: value.price,
             category: value.category,
             image: value.image,
             slug: value.slug,
             flagimage: "/images/svg/map-pointer.svg",
             flagHighlight: "/images/svg/map-pointer-highlight.svg",
             position: { lat: Number(value.lat), lng: Number(value.lon)},
          })
        }
      })

      setmarkerArray(markersArray);

      if (window.innerWidth > 1023) {

        setTimeout(() => {
      
          var cat = document.querySelector('.category-container').offsetHeight;
          var top = document.querySelector('.top-bar').offsetHeight;
          var usp = document.querySelector('.module__height').offsetHeight;
      
          var header = cat + top + usp;
      
          const stickyHeight = document.querySelector('#react-product-grid').offsetHeight;
          const newStickyHeight = stickyHeight - 220;
          document.querySelector('#safari-container').setAttribute("style", "height:" + ( newStickyHeight ) + "px");
          document.querySelector('#bottom-content').setAttribute("style", "height:" + ( newStickyHeight ) + "px");
      
          // When the user scrolls the page, execute myFunction
          window.onscroll = function() {myFunction()};
      
          var map = document.querySelector(".testmap");
      
          // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
          function myFunction() {
            if (window.pageYOffset > header) {
              map.classList.add("sticky");
            } else {
              map.classList.remove("sticky");
            }
            if (window.pageYOffset > newStickyHeight ) {
              map.classList.remove("sticky");
            }
          }
        }, 2000);
      }
  }, []);

  const markers = markerArray;

  const [activeMarker, setActiveMarker] = useState();
  const [hover, setHover] = useState(false);
  const [flagIcon, setFlagIcon] = useState("/images/svg/map-pointer.svg");

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  const containerStyle = {
    width: "100%",
    height: "100vh"
  };

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyCJ5oNEfyzA-ycLRJkaPWD1EinqoSOh2uM"
  });

  const [map, setMap] = React.useState(null);

  const onLoad = React.useCallback(function callback(map) {

    const bounds = new window.google.maps.LatLngBounds();
    markers && markers.map(x => {
      const marker = createMarker(x);
      bounds.extend(x.position)
      });

    map.fitBounds(bounds);
    const zoomChangeBoundsListener =
      window.google.maps.event.addListenerOnce(map, 'bounds_changed', function(event) {
        if (this.getZoom()){
          this.setZoom(13);
        }
    });
    setTimeout(function(){google.maps.event.removeListener(zoomChangeBoundsListener)}, 2000);
    setMap(map);

  });

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  // create marker on google map
  const createMarker = (markerObj) => {
    const marker = new window.google.maps.Marker({
      position: markerObj.position,
      map: map,
      id: markerObj.id
    });

    const infowindow = new window.google.maps.InfoWindow({ content: markerObj.name });
    marker.addListener("click", () => infowindow.open(map, marker));

    return marker;
  }

  function handleMouseOver( marker ) {

    const newArr = markers.map(obj => {
      if (obj.id === marker) {
         var anchor = document.querySelector('#experience-' + obj.id);
         anchor.scrollIntoView();
      	 highlightItem( obj.id );
        return {...obj, flagimage: "/images/svg/map-pointer-highlight.svg"};
      }
      return obj;
    });

    setmarkerArray(newArr);
  }

  function handleMouseOut( marker ) {

    const newArr = markers.map(obj => {
      if (obj.id === marker) {
      	highlightItem( 0 );
        return {...obj, flagimage: "/images/svg/map-pointer.svg"};
      }
      return obj;
    });

    setmarkerArray(newArr);
  }

  var markerClusterOptions = {
		gridSize: 10,
    maxZoom: 20,
		styles: [{
			width: 50,
			height: 50,

			url: 'data:image/svg+xml;base64,' + window.btoa('<svg xmlns="http://www.w3.org/2000/svg" width="56.499" height="74" viewBox="0 0 56.499 74"><g transform="translate(1623.5 22583.199)"><g transform="translate(-2606 -23325)"><path d="M23.552,68.588C3.687,39.789,0,36.834,0,26.25a26.25,26.25,0,1,1,52.5,0c0,10.584-3.687,13.539-23.552,42.338a3.283,3.283,0,0,1-5.4,0Zm2.7-31.4A10.937,10.937,0,1,0,15.312,26.25,10.937,10.937,0,0,0,26.25,37.187Z" transform="translate(984.5 743.801)" fill="#fd932b"/><path d="M26.25,70a3.258,3.258,0,0,0,2.7-1.412C48.812,39.789,52.5,36.834,52.5,26.25a26.25,26.25,0,1,0-52.5,0C0,36.834,3.687,39.789,23.552,68.588A3.258,3.258,0,0,0,26.25,70m0-54.688A10.937,10.937,0,1,1,15.312,26.25,10.937,10.937,0,0,1,26.25,15.312M26.25,72a5.281,5.281,0,0,1-4.342-2.274c-3.54-5.132-6.52-9.377-9.148-13.122C6.754,48.049,3.129,42.884.955,38.669A24.49,24.49,0,0,1-2,26.25,28.242,28.242,0,0,1,46.225,6.274,28.168,28.168,0,0,1,54.5,26.25a24.49,24.49,0,0,1-2.955,12.419c-2.173,4.215-5.8,9.379-11.8,17.935-2.629,3.745-5.608,7.989-9.146,13.119A5.283,5.283,0,0,1,26.25,72Zm0-54.688a8.937,8.937,0,1,0,8.937,8.938A8.948,8.948,0,0,0,26.25,17.312Z" transform="translate(984.5 743.801)" fill="#fff"/></g><path d="M17,0A17.255,17.255,0,0,1,34,17.5,17.255,17.255,0,0,1,17,35,17.255,17.255,0,0,1,0,17.5,17.255,17.255,0,0,1,17,0Z" transform="translate(-1612 -22572)" fill="#fd932b"/><path d="M17,0A17.255,17.255,0,0,0,0,17.5,17.255,17.255,0,0,0,17,35,17.255,17.255,0,0,0,34,17.5,17.255,17.255,0,0,0,17,0m0-2A18.466,18.466,0,0,1,24.416-.458a18.915,18.915,0,0,1,6.04,4.191,19.47,19.47,0,0,1,4.059,6.2,20.034,20.034,0,0,1,0,15.144,19.47,19.47,0,0,1-4.059,6.2,18.915,18.915,0,0,1-6.04,4.191,18.607,18.607,0,0,1-14.831,0,18.915,18.915,0,0,1-6.04-4.191,19.47,19.47,0,0,1-4.059-6.2,20.034,20.034,0,0,1,0-15.144,19.47,19.47,0,0,1,4.059-6.2A18.915,18.915,0,0,1,9.584-.458,18.466,18.466,0,0,1,17-2Z" transform="translate(-1612 -22572)" fill="#fff"/></g></svg>'),
			textColor: 'white',
			textSize: 20,
      textAlign: 'center',
		}]
	};

  return isLoaded ? (
      <GoogleMap
        mapContainerStyle={containerStyle}
        onLoad={onLoad}
        onUnmount={onUnmount}
        onDragEnd={() => console.log(map.getCenter().lat())}
        zoom={15}
      >
        {
        <MarkerClusterer
          options={markerClusterOptions}
        >
          {clusterer =>
            markers && markers.map(({ id, name, supplier, price, slug, category, image, flagimage, flagHighlight, iconsize, position }) => (
              <Marker
                key={id}
                position={position}
                onClick={() => handleActiveMarker(id)}
                clusterer={clusterer}
                icon={{
                  url: highlighted == id ? flagHighlight : flagimage,
                  scaledSize: new google.maps.Size(60,60)
                }}
                onMouseOver={()=> handleMouseOver(id)}
                onMouseOut={()=> handleMouseOut(id)}
              >
                {activeMarker === id ? (
                  <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                    <div>
                    <div className="activity-map__popup--image"><img src={`${cdnPath}/${image}?w=400&h=300&fit=crop&auto=compress`} alt={name}/></div>
                      <div className="activity-map__popup--name">{name}</div>
                      <div className="activity-map__popup--supplier">{supplier}</div>
                      <div className="activity-map__popup--price"><p>From <span>&pound;{price}</span> pp</p></div>
                      <a href={withLinkParams(`/products/${slug}`)} target="_blank" rel="noopener" className="button primary small">view</a>
                    </div>
                  </InfoWindow>
                ) : null }
              </Marker>
          ))
          }
        </MarkerClusterer>
        /* Child components, such as markers, info windows, etc. */
      }
        <></>
      </GoogleMap>
) : (
    <></>
  );
}

export default React.memo(Map);
